var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special_article"},[_c('h3',{staticClass:"title"},[_c('img',{attrs:{"src":_vm.titleImage,"alt":"落とし穴"}})]),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }